import type { ReactNode } from "react";

export interface PeriodSummaryProps {
  /** Rótulo en versalitas ("Este mes"). */
  label: string;
  /** Cifra protagonista con flecha o signo ("↑ $10,360"). */
  value: string;
  tone?: "positive" | "negative";
  /** Desglose en una línea ("↑ Ingresos $12,400 · ↓ Gastos -$2,040"). */
  breakdown?: string;
  /** Frase de contexto bajo el desglose. */
  hint?: ReactNode;
}

/**
 * Port de `PeriodSummary` del design system, sin tarjeta: cifra de 44px (72px desde lg)
 * con color semántico, desglose en una línea y frase de contexto.
 */
export function PeriodSummary({ label, value, tone, breakdown, hint }: PeriodSummaryProps) {
  const toneClass =
    tone === "positive"
      ? "text-[var(--app-success)]"
      : tone === "negative"
        ? "text-[var(--app-danger)]"
        : "";

  return (
    <div className="text-[var(--app-text)]">
      <div className="text-[11px] font-medium uppercase leading-[14px] tracking-[0.18em] text-[var(--app-text-secondary)]">
        {label}
      </div>
      <div
        className={`mt-1 font-[var(--app-font-display)] text-[44px] font-medium leading-none tracking-[-0.04em] tabular-nums lg:mt-2 lg:text-[72px] ${toneClass}`}
      >
        {value}
      </div>
      {breakdown ? (
        <div className="mt-2 text-sm leading-5 font-medium lg:mt-3 lg:text-base lg:leading-6">{breakdown}</div>
      ) : null}
      {hint ? (
        <p className="mt-2 max-w-[440px] text-[15px] leading-[22px] text-[var(--app-text-secondary)]">{hint}</p>
      ) : null}
    </div>
  );
}
